import { createFileRoute, Link } from "@tanstack/react-router";
import { useState } from "react";
import { supabase } from "@/integrations/supabase/client";

export const Route = createFileRoute("/forgot-password")({
  head: () => ({
    meta: [
      { title: "Recuperar contraseña | Mine Class" },
      { name: "description", content: "Recupera el acceso a tu cuenta Mine Class enviándote un enlace por correo electrónico." },
      { name: "robots", content: "noindex,nofollow" },
    ],
  }),
  component: ForgotPassword,
});

function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState<string | null>(null);
  const [err, setErr] = useState<string | null>(null);

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setBusy(true);
    setErr(null);
    setMsg(null);
    try {
      const { error } = await supabase.auth.resetPasswordForEmail(email, {
        redirectTo: `${window.location.origin}/reset-password`,
      });
      if (error) throw error;
      setMsg("Si el correo existe, te enviamos un enlace para restablecer tu contraseña.");
    } catch (e) {
      setErr(e instanceof Error ? e.message : "Error inesperado.");
    } finally {
      setBusy(false);
    }
  }

  return (
    <main className="min-h-dvh flex items-center justify-center bg-[var(--color-surface-container-low)] px-4">
      <div className="w-full max-w-md bg-white border border-[var(--color-outline-variant)] p-8">
        <h1 className="text-2xl font-bold text-[var(--color-brand-purple)]">Recuperar contraseña</h1>
        <p className="text-sm text-[var(--color-on-surface-variant)] mt-1">
          Te enviaremos un enlace a tu correo <strong>@mine-class.cl</strong>.
        </p>
        <form
          onSubmit={submit}
          className="space-y-3 mt-6"
          aria-label="Recuperar contraseña"
          aria-busy={busy}
          aria-describedby={err ? "fp-error" : msg ? "fp-msg" : undefined}
        >
          <label htmlFor="fp-email" className="sr-only">Correo electrónico</label>
          <input
            id="fp-email"
            name="email"
            type="email"
            autoComplete="email"
            inputMode="email"
            required
            aria-required="true"
            aria-invalid={!!err}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="correo@mine-class.cl"
            className="w-full border border-[var(--color-outline-variant)] px-4 py-3 outline-none focus:border-[var(--color-brand-coral)]"
          />
          <div aria-live="assertive" aria-atomic="true" className="min-h-[1rem]">
            {err && <p id="fp-error" role="alert" className="text-sm text-red-600">{err}</p>}
            {msg && <p id="fp-msg" role="status" className="text-sm text-green-700">{msg}</p>}
          </div>
          <button
            type="submit"
            disabled={busy}
            aria-disabled={busy}
            className="w-full py-3 bg-[var(--color-brand-coral)] text-white font-bold uppercase tracking-wider hover:brightness-110 disabled:opacity-50"
          >
            {busy ? "Enviando..." : "Enviar enlace"}
          </button>
        </form>
        <div className="mt-4 text-sm">
          <Link to="/auth" className="underline text-[var(--color-brand-purple)]">Volver a iniciar sesión</Link>
        </div>
      </div>
    </main>
  );
}

